import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { withContext } from '../../common/etgs-context';
import Menu from './Menu';
import useDrawerControl from '../../common/hooks/useDrawerControl';
import HeaderComponent from '../header-app/HeaderComponent';
import logoTGS from "../../assets/images/logoTGS.png"
import { Typography } from '@material-ui/core';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: 0,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(0),
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 0.5),
        height:46
        // necessary for content to be below app bar
        //...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    itemText:{
        whiteSpace:"normal",
        padding:0,
    },
    listItem:{
        padding:0,
    },
    alingTextFooter:{
        textAlign:'center'
    },
}));

const NavContent = (props) => { 
    const classes = useStyles();
    const theme = useTheme();
    const {open, toggleDrawer} = useDrawerControl()

    return (
        <div className={classes.root}>
            <CssBaseline />
            <HeaderComponent
                open={open}
                daysToPasswordExpiration={props.user.daysToPasswordExpiration}
                passwordExpires={props.user.passwordExpires}
                passwordStatus={props.user.passwordStatus}
                toggle={toggleDrawer}
                anchor={props.handleChangeAnchor}
            />

            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <img src={logoTGS} className="logoTGS" alt="logoTGS" />
                    <IconButton onClick={toggleDrawer}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <Divider />
                <Menu items={props.context.menu.submenu} classes={classes} /> 
                <div className="drawerFooter" style={{marginTop:'auto'}}>
                    <Typography variant="subtitle2" color="textSecondary" className={classes.alingTextFooter}>
                        {`Copyright © TGS 2019-${new Date().getFullYear()} `}
                    </Typography>
                    <Typography className={classes.alingTextFooter}>v1.18.34</Typography>
                </div>
            </Drawer>
        </div>
    );
}
export default withContext(NavContent)
